import { render } from "./OpenFormComp.vue?vue&type=template&id=7f73f399&scoped=true&ts=true"
import script from "./OpenFormComp.vue?vue&type=script&lang=ts"
export * from "./OpenFormComp.vue?vue&type=script&lang=ts"

import "./OpenFormComp.vue?vue&type=style&index=0&id=7f73f399&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f73f399"]])

export default __exports__